import { UrlMatchResult, UrlSegment } from '@angular/router';

// The guest app is served under /p/. Guest links typed or pasted without it
// (/book/add/<slug>, /waitlist/<id>), or with the API's /public/ prefix instead, used to
// fall through to the login page, where some guests created a business account.
const PUBLIC_PREFIX = 'public';

// Parameters each guest page needs before the guest app can open it: a business slug or
// party id, and for booking an action or a reservation id too
const SLUG_ONLY = 1;
const SLUG_AND_ID = 2;
const GUEST_PAGE_PARAMS = new Map([
  ['waitlist', SLUG_ONLY],
  ['check-in', SLUG_ONLY],
  ['book', SLUG_AND_ID],
]);

const isGuestPage = (page: string | undefined): boolean => (
  GUEST_PAGE_PARAMS.has(page ?? '')
);

// The guest app address for a manager URL, or null when it lacks the business to open
export function guestAppUrl(url: string): string | null {
  const [path, ...suffixParts] = url.split(/(?=[?#])/u);
  const suffix = suffixParts.join('');

  const segments = path.split('/').filter(Boolean);
  const pageSegments = segments[0] === PUBLIC_PREFIX ? segments.slice(1) : segments;
  const [page, ...params] = pageSegments;

  if (!isGuestPage(page) || params.length < (GUEST_PAGE_PARAMS.get(page) ?? 0)) {
    return null;
  }

  return `/p/${pageSegments.join('/')}${suffix}`;
}

// Matches the URLs that look like guest links. /waitlist alone is the manager's own page.
export function guestLinkMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const [first, second] = segments.map(segment => segment.path);
  const isGuestLink = first === PUBLIC_PREFIX ||
    (isGuestPage(first) && (first !== 'waitlist' || second !== undefined));

  return isGuestLink ? { consumed: segments } : null;
}
